<template>
  <div class="col-12 c">
    <div class="card">
      <div class="card-header">
        <h4 class="text-center">
          <i class="fa fa-file-o"></i>
          LOGS <strong class="text-danger">للمطورين</strong>
        </h4>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label for="">اختر يوم معين</label>
          <input
            type="date"
            class="form-control"
            v-model="date"
            @change="get()"
          />
          <small id="helpId" class="form-text text-muted"
            >افتراضي يُعرض احدث 100 سجل. قم باختيار اليوم لعرض كل سجلاته</small
          >
        </div>
        <div class="col-12 table-responsive">
          <table class="table table-hover table-bordered custom-table">
            <thead>
              <th>url</th>
              <th>content</th>
              <th>date</th>
            </thead>
            <tbody>
              <tr v-for="log in logs" :key="log._id">
                <td>
                  <input
                    type="text"
                    class="form-control"
                    readonly
                    v-model="log.url"
                    dir="ltr"
                    name=""
                    id=""
                  />
                </td>
                <td>
                  <textarea dir="ltr" class="form-control" readonly>{{
                    log.body
                  }}</textarea>
                </td>
                <td>
                  {{ log.date }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (this.user.admin_id) {
      alert("هذه الصفحة لحساب المدرسة الرئيسي فقط وليس للمشرفين");
      this.$router.push("/");
    }
    if (!checkPer("settings")) {
      this.$router.push("/per");
      return false;
    }
    var g = this;
    g.get();
  },
  data() {
    return {
      logs: [],
      user: JSON.parse(localStorage.getItem("user")),
      date: null,
    };
  },
  methods: {
    get() {
      var g = this;
      $.post(api + "/user/general/logs", {
        jwt: g.user.jwt,
        date: g.date,
      })
        .then(function (r) {
          g.logs = r;
        })
        .catch(function (r) {
          alert("حدث خطأ");
        });
    },
  },
};
</script>

<style>
</style>